import { render, staticRenderFns } from "./BillingWidget.vue?vue&type=template&id=e241e9a8&scoped=true"
import script from "./BillingWidget.ts?vue&type=script&lang=ts&external"
export * from "./BillingWidget.ts?vue&type=script&lang=ts&external"
import style0 from "./BillingWidget.vue?vue&type=style&index=0&id=e241e9a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e241e9a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e241e9a8')) {
      api.createRecord('e241e9a8', component.options)
    } else {
      api.reload('e241e9a8', component.options)
    }
    module.hot.accept("./BillingWidget.vue?vue&type=template&id=e241e9a8&scoped=true", function () {
      api.rerender('e241e9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/components/BillingSection/BillingWidget/BillingWidget.vue"
export default component.exports